/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const truncate = (str: string, length: number = 100, ending: string = '...') => {
  return str.length > length ? str.substring(0, length - ending.length) + ending : str;
};
